export const SECTION_ITEMS_ACTION = 'SECTION_ITEMS_ACTION';
export const SECTION_ITEMS_SUCCESS_ACTION = 'SECTION_ITEMS_SUCCESS_ACTION';
export const SECTION_ITEMS_FAILURE_ACTION = 'SECTION_ITEMS_FAILURE_ACTION';
